import Vue from "vue";
import i18n from "@/libs/i18n/i18n";
import { initialState } from "./initialState";
export default {
  SET_USERS: (state, payload) => {
    state.users = JSON.parse(JSON.stringify(payload));
  },
  SET_TOTAL: (state, payload) => {
    state.total = payload;
  },
  SET_ROLES: (state, payload) => {
    state.roles = payload;
  },
  SET_ROLE: (state, payload) => {
    state.role = payload;
  },
  SET_UNIT: (state, payload) => {
    state.unit = payload;
  },
  SET_FIRSTNAME: (state, payload) => {
    state.firstName = payload;
  },
  SET_LASTNAME: (state, payload) => {
    state.lastName = payload;
  },
  SET_USERNAME: (state, payload) => {
    state.username = payload;
  },
  SET_PASSWORD: (state, payload) => {
    state.password = payload;
  },
  SET_CONFIRM: (state, payload) => {
    state.confirm = payload;
  },
  SET_MOBILE: (state, payload) => {
    state.mobile = payload;
  },
  SET_DATE_OF_BIRTH: (state, payload) => {
    state.dateOfBirth = payload;
  },
  SET_MOBILE_COUNTRY_ID: (state, payload) => {
    state.mobileCountryId = payload;
  },
  SET_FATHERNAME: (state, payload) => {
    state.fatherName = payload;
  },
  SET_NATIONALCODE: (state, payload) => {
    state.nationalCode = payload;
  },
  SET_MARITALSTATUS: (state, payload) => {
    
    state.maritalStatus = payload;
  },
  SET_OTHERCODE: (state, payload) => {
    state.otherCode = payload;
  },
  SET_EXPIRY_DATE_OF_IDENTITY_DOCUMENT: (state, payload) => {
    state.expiryDateOfIdentityDocument = payload;
  },
  SET_TYPE_OF_IDENTIFICATION_DOCUMENT: (state, payload) => {
    state.typeOfIdentificationDocument = payload;
  },
  SET_TYPE_OF_IDENTIFICATION_DOCUMENTS: (state, payload) => {
    state.typeOfIdentificationDocuments = payload;
  },
  SET_FOREFATHER_NAME: (state, payload) => {
    state.forefatherName = payload;
  },
  SET_MOBILES: (state, payload) => {
    state.mobiles = payload;
  },
  SET_COUNTRY: (state, payload) => {
    
    state.country = payload;
  },
  SET_CITY: (state, payload) => {
    state.city = payload;
  },
  SET_PROVINCE: (state, payload) => {
    state.province = payload;
  },
  // SET_ISSUEDCOUNTRY: (state, payload) => {
  //     
  //     state.issuedCountry = payload;
  // },
  // SET_BIRTHPROVINCE: (state, payload) => {
  //   state.birthProvince = payload;
  // },

  SET_BIRTHCITY: (state, payload) => {
    state.birthCity = payload;
  },
  SET_PLACE_OF_BIRTH_CITY_FOR_FOREIGN: (state, payload) => {
    state.placeOfBirthCityForForeign = payload;
  },
  SET_GENDER: (state, payload) => {
    
    state.gender = payload;
  },
  SET_ROLE_FILTER: (state, payload) => {
    state.roleFilter = payload;
  },
  SET_ADDRESSES: (state, payload) => {
    state.addresses = payload;
  },
  SET_ADDRESSTYPES: (state, payload) => {
    state.addressTypes = payload;
  },
  SET_ADDRESS_CITIES: (state, payload) => {
    state.addressCities = payload;
  },
  SET_EMAIL: (state, payload) => {
    state.email = payload;
  },
  SET_PHONES: (state, payload) => {
    state.phones = payload;
  },
  SET_REFERRAL_WAYS: (state, payload) => {
    state.referralWays = payload;
  },
  SET_SOCIAL_NETWORKS: (state, payload) => {
    state.socialNetworks = payload;
  },
  SET_REFERRAL_WAY: (state, payload) => {
    state.referralWay = payload;
  },
  SET_REFERRER_NAME: (state, payload) => {
    state.referrerName = payload;
  },
  SET_REFERRER_USER: (state, payload) => {
    state.referrerUser = payload;
  },
  SET_REFERRER_USERS: (state, payload) => {
    
    state.referrerUsers = payload;
  },
  SET_REFERRER_ADDRESS: (state, payload) => {
    state.referrerAddress = payload;
  },
  SET_REFERRER_NATIONALCODE: (state, payload) => {
    state.referrerNationalCode = payload;
  },
  SET_USER_TO_EDIT: (state, payload) => {
    state.userToEdit = payload;
  },
  SET_USER_SERVICE_TO_EDIT: (state, payload) => {
    
    //Object.assign(state.userServiceEdit, JSON.parse(JSON.stringify(payload))) ;
    state.userServiceEdit = payload;
  },
  SET_USER_ADD_SERVICE: (state, payload) => {
    state.userAddService = payload;
  },
  SET_SERVICE_TO_ADD: (state, payload) => {
    state.serviceToAdd = payload;
  },
  SET_USERS_TO_ADD: (state, payload) => {
    // Object.assign( state.usersToAdd, JSON.parse(JSON.stringify(payload))) ;

    state.usersToAdd = _.cloneDeep(payload);
  },
  SET_USERS_TO_ADD_INDEX: (state, payload) => {
    state.usersToAddIndex = payload;
  },
  SET_SPOUSES: (state, payload) => {
    state.spouses = payload;
  },
  SET_SPOUSES_TO_DELETE: (state, payload) => {
    state.spousesToDelete = payload;
  },
  SET_FOREIGN_USER_TO_SEARCH: (state, payload) => {
    state.foreignUserToSearch = payload;
  },
  RESET_FOREIGN_USER_TO_SEARCH(state) {
    // To reset the entire module
    Object.assign(
      state.foreignUserToSearch,
      JSON.parse(JSON.stringify(_.cloneDeep(initialState.foreignUserToSearch)))
    );
  },
  SET_SEARCHED_FOREIGNERS: (state, payload) => {
    state.serviceGender = payload;
  },
  SET_SERVICE_GENDER: (state, payload) => {
    state.searchedForeigners = payload;
  },
  SET_USER_PROFILE: (state, payload) => {
    
    state.userProfile = payload;
  },
  RESET_MODULE(state) {
    // To reset the entire module
    // state = JSON.parse(JSON.stringify(initialState));
    // Object.assign(state, JSON.parse(JSON.stringify(_.cloneDeep(initialState))))
    Object.assign(state, JSON.parse(JSON.stringify(_.cloneDeep(initialState))));
  },
  SET_BIRTH_CERTIFICATE_ID: (state, payload) => {
    state.birthCertificateId = payload;
  },
  SET_MEDICAL_SYSTEM_NUMBER: (state, payload) => {
    state.medicalSystemNumber = payload;
  },
  SET_START_DATE_AT_WORK: (state, payload) => {
    state.startDateAtWork = payload;
  },
  SET_END_DATE_AT_WORK: (state, payload) => {
    state.endDateAtWork = payload;
  },
  SET_COMPLETION_DATE_OF_MEDICAL_LICENSE: (state, payload) => {
    state.completionDateOfMedicalLicense = payload;
  },
  SET_OFFICE_LICENSE_NUMBER: (state, payload) => {
    state.officeLicenseNumber = payload;
  },
  SET_FACULTY_STATUS: (state, payload) => {
    state.facultyStatus = payload;
  },
  SET_COOPERATION_TYPE: (state, payload) => {
    state.cooperationType = payload;
  },
  SET_ACCOUNT_NUMBER: (state, payload) => {
    state.accountNumber = payload;
  },
  SET_IBAN: (state, payload) => {
    state.iBAN = payload;
  },
  SET_ACCOUNT_TYPE: (state, payload) => {
    state.accountType = payload;
  },
  SET_DESCRIPTION: (state, payload) => {
    state.description = payload;
  },
  SET_MEDICAL_SPECIALTY_ID: (state, payload) => {
    state.medicalSpecialtyId = payload;
  },
  SET_MEDICAL_SCIENTIFIC_DEGREE_ID: (state, payload) => {
    state.medicalScientificDegreeId = payload;
  },
  SET_BANK_ID: (state, payload) => {
    state.bankId = payload;
  },
  SET_DATE_OF_GRADUATION: (state, payload) => {
    state.dateOfGraduation = payload;
  },
  SET_FIELD_OF_STUDY: (state, payload) => {
    state.fieldOfStudy = payload;
  },
  SET_JOB: (state, payload) => {
    state.job = payload;
  },
  SET_EDUCATIONAL_DEGREE: (state, payload) => {
    state.educationalDegree = payload;
  },
  SET_CITIZEN_IDENTIFICATION_DOCUMENT: (state, payload) => {
    state.citizenIdentificationDocument.push(payload);
  },
  SET_ALL_FILES: (state, files) => {
    state.allFiles = files;
  },
  SET_LEGAL_FILE_NUMBER: (state, legalFileNumber) => {
    state.legalFileNumber = legalFileNumber;
  },
  SET_INSURANCE_NUMBER: (state, insuranceNumber) => {
    state.insuranceNumber = insuranceNumber;
  },
  ADD_TO_EDITED_FILES: (state, file) => {
    state.editedFiles.push(file);
  },
  SET_EDITED_FILES: (state, files) => {
    state.editedFiles = files;
  },
  SET_FILES_LIST: (state, files) => {
    state.filesList = files;
  },
  EDIT_FILES_LIST: (state, payload) => {
    
    state.filesList[payload.index] = payload.file;
  },
  REMOVE_FROM_FILES_LIST: (state, payload) => {
    state.filesList.splice(payload.index, 1);
  },
  ADD_TO_FILES_LIST: (state, file) => {
    state.filesList.push(file);
  },
  ADD_TO_ALL_FILES: (state, file) => {
    state.allFiles.push(file);
  },
  ADD_TO_ADDED_FILES: (state, file) => {
    state.addedFiles.push(file);
  },
  ADD_TO_REMOVAL_FILES: (state, file) => {
    state.removalFiles.push({ attachFileId: file.file._id });
    state.filesList.splice(_.indexOf(state.filesList, file), 1);
  },
  SET_ADDED_FILES: (state, file) => {
    state.addedFiles = file;
  },
  SET_ATTACHED_PAYLOAD: (state, payload) => {
    state.attachedPayload = payload;
  },
  ADD_TO_ATTACHED_PAYLOAD: (state, payload) => {
    state.attachedPayload.push(payload);
  },
};
